import React from 'react';
import 'whatwg-fetch';
import InputUpdate from '../input/inputUpdate';
import TextAreaUpdate from '../input/textareaUpdate';

import routerIcon from 'src/images/icons/router.svg';
import SubNavBar from '../SubNavBar';
import withAuth from 'src/hoc/withAuth';

const apiCustomerShow = '/api/customer/show/';

class DisplayCustomerTechnical extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      fatalError: undefined,
      technicalInformation: '____',
      typeMaintenance: '____',
    };

    this.updateField = this.updateField.bind(this);
  }

  componentDidMount() {
    if (this.props.match.params.id) {
      this.setState({ fatalError: undefined });
      const paramsID = this.props.match.params.id;

      let queryURL = apiCustomerShow;
      let graphQL = '{ customer(id:' + paramsID + '){ id, typeMaintenance, technicalInformation } }';
      queryURL += graphQL;
      this.props
        .authFetch(queryURL, {
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          method: 'GET',
        })
        .then((resp) => resp.json())
        .then((data) => {
          if (data['data']['customer']) {
            this.setState({
              typeMaintenance: data['data']['customer']['typeMaintenance'],
              technicalInformation: data['data']['customer']['technicalInformation'],
            });
          } else {
            let message = 'Erreur lors de la récupération du client';

            if (data['errors'] && data['errors'].length > 0) {
              message = data['errors'].map((e) => e.message).join(', ');
            }

            throw new Error(message);
          }
        })
        .catch((error) => {
          this.setState({ fatalError: error.message });
        });
    }
  }

  render() {
    const styles = {
      image: {
        width: '80px',
      },
    };

    return (
      <div id='appView' className='div-entity'>
        <SubNavBar goBack={this.props.history.goBack} title='Informations techniques' />

        <div id='appViewContent'>
          {!this.state.fatalError ? (
            <div className='entity-display'>
              <form>
                <InputUpdate
                  inputType='text'
                  inputLabel='Maintenance du client'
                  inputValue={this.state.typeMaintenance}
                  submitUpdate={(inputValue) => this.updateField(inputValue.replaceAll('\t', ' '), 'typeMaintenance')}
                  toggleBlackOut={() => this.props.toggleBlackOut()}
                />

                <img style={styles.image} src={routerIcon} />

                <TextAreaUpdate
                  inputType='text'
                  inputLabel='Spécifications'
                  inputValue={this.state.technicalInformation}
                  submitUpdate={(inputValue) =>
                    this.updateField(inputValue.replaceAll('\t', ' '), 'technicalInformation')
                  }
                  toggleBlackOut={() => this.props.toggleBlackOut()}
                />
              </form>
            </div>
          ) : (
            <div className='alert alert-danger' role='alert'>
              {this.state.fatalError}
            </div>
          )}
        </div>
      </div>
    );
  }

  updateField(newValue, fieldName) {
    const newValueSent = JSON.stringify(newValue);

    let graphQL = 'mutation { customer(id:' + this.props.match.params.id + ', ';
    graphQL += fieldName + ':' + newValueSent + ') { ' + fieldName + ' } }';

    let queryURL = apiCustomerShow;
    let data = 'data=' + encodeURIComponent(graphQL);
    this.props
      .authFetch(queryURL, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        method: 'POST',
        body: data,
      })
      .then((resp) => resp.json())
      .then((data) => {
        if (data['data']['customer'][fieldName] === newValue) {
          this.props.openToast(true, 'Votre modification a bien été prise en compte.');
          this.componentDidMount();
        } else {
          this.props.openToast(false, 'Erreur lors de la modification. Veuillez réessayer.');
        }
      })
      .catch(() => {
        this.props.openToast(false, 'Erreur lors de la modification. Veuillez réessayer.');
      });
  }
}

export default withAuth(DisplayCustomerTechnical);
